import Commission from './index';

export default { path: '/home/commission', component: Commission };
